/**
 * Client-side GA4 Event Tracking
 * Uses react-ga4 to send custom events to Google Analytics
 */

import ReactGA from 'react-ga4';

/**
 * Track template card click (Buy Now button on grid)
 */
export const trackTemplateClick = (templateName, templatePrice) => {
  ReactGA.event({
    category: 'Template',
    action: 'Click Buy Now',
    label: templateName,
    value: templatePrice
  });
};

/**
 * Track live preview click
 */
export const trackPreviewClick = (templateName) => {
  ReactGA.event({
    category: 'Template',
    action: 'Click Preview',
    label: templateName
  });
};

/**
 * Track checkout modal open
 */
export const trackModalOpen = (templateName, templatePrice) => {
  ReactGA.event({
    category: 'Checkout',
    action: 'Modal Opened',
    label: templateName,
    value: templatePrice
  });
};

/**
 * Track add-on selection in checkout modal
 */
export const trackAddOnSelect = (addOnName, selected, templateName) => {
  ReactGA.event({
    category: 'Checkout',
    action: selected ? 'Add-On Selected' : 'Add-On Deselected',
    label: `${addOnName} - ${templateName}`
  });
};

/**
 * Track proceed to checkout click
 */
export const trackCheckoutClick = (templateName, totalPrice, addOns) => {
  ReactGA.event({
    category: 'Checkout',
    action: 'Proceed to Stripe',
    label: templateName,
    value: totalPrice
  });

  // Also send as e-commerce event
  ReactGA.event('begin_checkout', {
    currency: 'USD',
    value: totalPrice,
    items: [{
      item_name: templateName,
      price: totalPrice
    }],
    add_ons: addOns.join(', ')
  });
};

/**
 * Track template detail page view
 */
export const trackTemplateView = (templateName, templatePrice) => {
  ReactGA.event('view_item', {
    currency: 'USD',
    value: templatePrice,
    items: [{
      item_name: templateName,
      price: templatePrice
    }]
  });
};

/**
 * Track checkout modal close (abandoned)
 */
export const trackModalClose = (templateName) => {
  ReactGA.event({
    category: 'Checkout',
    action: 'Modal Closed',
    label: templateName
  });
};
